/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Toast_CreatedInputs */

const vi_warehouse_position_toast_created = /** @type {(inputs: Warehouse_Position_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo vị trí`)
};

/**

* @param {Warehouse_Position_Toast_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_toast_created = /** @type {((inputs?: Warehouse_Position_Toast_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Toast_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_toast_created(inputs)
});